import { render, staticRenderFns } from "./knowledge_page_mng.vue?vue&type=template&id=d0f4fbbc"
import script from "./knowledge_page_mng.vue?vue&type=script&lang=js"
export * from "./knowledge_page_mng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0f4fbbc')) {
      api.createRecord('d0f4fbbc', component.options)
    } else {
      api.reload('d0f4fbbc', component.options)
    }
    module.hot.accept("./knowledge_page_mng.vue?vue&type=template&id=d0f4fbbc", function () {
      api.rerender('d0f4fbbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/knowledge_page_mng.vue"
export default component.exports